import React from "react";
import { useTranslation } from "react-i18next";
import {
  allPatientTypes,
  PatientTypeEnum,
  translateKey,
} from "common/enums/PatientTypeEnum";
import { GlobalState } from "store/configure-store";
import { selectPatientType } from "store/reducers/patient.reducer";
import { connect } from "react-redux";
import { setPatientType } from "store/actions/patient.actions";
import Card from "@cc/react-components/Card";
import ListGroup from "ui/ListGroup";
import Page from "ui/Page";
import { PV_PATIENT_TYPE } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";

export interface Props {
  patientType: PatientTypeEnum;
  setPatientType(patientTypeEnum: PatientTypeEnum): void;
}

const PatientTypeContainer = ({ patientType, setPatientType }: Props) => {
  const [t] = useTranslation();

  useTrackPageView(PV_PATIENT_TYPE);

  const renderResults = (patientTypes: PatientTypeEnum[]) => {
    return (
      <ListGroup>
        {patientTypes.map((type, index) => (
          <ListGroup.ItemMobile
            key={index}
            active={patientType === type}
            onClick={() => setPatientType(type)}
          >
            {t(translateKey(PatientTypeEnum[type]))}
          </ListGroup.ItemMobile>
        ))}
      </ListGroup>
    );
  };

  return (
    <Page.Scrollable>
      <Page.Body>
        <Card>
          <Card.Header>
            <Card.Title>{t("patientType.title")}:</Card.Title>
          </Card.Header>
        </Card>
        {renderResults(allPatientTypes())}
      </Page.Body>
    </Page.Scrollable>
  );
};

const mapStateToProps = (state: GlobalState) => {
  return {
    patientType: selectPatientType(state),
  };
};

export default connect(mapStateToProps, { setPatientType })(
  PatientTypeContainer
);
